/**
 * Debug logger for Hyperliquid telemetry (server + client).
 *
 * Server: enabled via `DEBUG_HYPERLIQUID=1` env var.
 * Client: enabled via `localStorage.setItem('HYPERLIQUID_DEBUG', '1')`.
 *
 * Without the gate, every deposit/withdraw/bridge pipeline step fans out
 * wallet addresses, amounts, and phase markers into the browser console
 * (client) or log aggregation (server).
 */
function isEnabled(): boolean {
	if (typeof window !== 'undefined') {
		try {
			return localStorage.getItem('HYPERLIQUID_DEBUG') === '1'
		} catch {
			return false
		}
	}
	return process.env.DEBUG_HYPERLIQUID === '1'
}

export function hlLog(...args: unknown[]): void {
	if (isEnabled()) console.log(...args)
}

export function hlWarn(...args: unknown[]): void {
	if (isEnabled()) console.warn(...args)
}
